import styled from 'styled-components';

export const StyledInput = styled.input`
  font-size: 1em;
  font-family: inherit;
`;
